import { render, staticRenderFns } from "./MenuPlannerAddress.vue?vue&type=template&id=56354625&scoped=true&"
import script from "./MenuPlannerAddress.vue?vue&type=script&lang=js&"
export * from "./MenuPlannerAddress.vue?vue&type=script&lang=js&"
import style0 from "./MenuPlannerAddress.vue?vue&type=style&index=0&id=56354625&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56354625",
  null
  
)

export default component.exports